import React, { useState, useEffect } from "react";

export default function LocationOverlay() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    // Fade in animation on mount
    setTimeout(() => setIsVisible(true), 100);

    // Handle responsive resize
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -200% center;
          }
          100% {
            background-position: 200% center;
          }
        }

        @keyframes borderGlow {
          0%, 100% {
            border-color: rgba(255, 215, 0, 0.3);
            box-shadow: 0 4px 24px rgba(0,0,0,0.18), 0 0 0 0 rgba(255, 215, 0, 0);
          }
          50% {
            border-color: rgba(255, 215, 0, 0.8);
            box-shadow: 0 4px 24px rgba(0,0,0,0.18), 0 0 20px 2px rgba(255, 215, 0, 0.4);
          }
        }

        @keyframes borderRotate {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        .location-overlay {
          animation: fadeInUp 0.6s ease-out;
          transition: all 0.3s ease;
          position: relative;
        }

        .location-overlay::before {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 12px;
          padding: 2px;
          background: linear-gradient(45deg, #FFD700, #FFA500, #FFD700, #FFA500);
          background-size: 300% 300%;
          animation: borderRotate 3s ease infinite;
          -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: xor;
          mask-composite: exclude;
          opacity: 0.6;
        }

        .location-overlay:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 32px rgba(255, 215, 0, 0.3);
        }

        .location-overlay:hover::before {
          opacity: 1;
          animation: borderRotate 1.5s ease infinite;
        }

        .location-icon {
          animation: bounce 2s ease-in-out infinite;
          transition: all 0.3s ease;
        }

        .location-overlay:hover .location-icon {
          animation: pulse 1s ease-in-out infinite;
          color: #FFF;
        }

        .location-link {
          position: relative;
          background: linear-gradient(90deg, #FFD700 0%, #FFF 50%, #FFD700 100%);
          background-size: 200% auto;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          transition: all 0.3s ease;
        }

        .location-link:hover {
          animation: shimmer 1.5s linear infinite;
        }

        .location-text {
          transition: all 0.3s ease;
        }

        .location-overlay:hover .location-text {
          color: #FFF;
        }
      `}</style>

      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
      />

      <div
        className="location-overlay"
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1000,
          background: "rgba(20,20,20,0.95)",
          color: "#FFD700",
          borderRadius: 12,
          boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
          padding: isMobile ? "10px 14px 10px 10px" : "18px 28px 18px 20px",
          display: "flex",
          alignItems: "center",
          gap: 12,
          minWidth: isMobile ? 140 : 220,
          fontWeight: 600,
          fontSize: isMobile ? 12 : 16,
          opacity: isVisible ? 1 : 0,
          backdropFilter: "blur(10px)",
          border: "2px solid rgba(255, 215, 0, 0.3)",
          overflow: "visible",
        }}
      >
        <i
          className="fas fa-map-marker-alt location-icon"
          style={{
            marginRight: 10,
            fontSize: isMobile ? 15 : 22,
            minWidth: isMobile ? 15 : 22,
            color: "#FFD700"
          }}
        ></i>
        <div style={{ flex: 1 }}>
          <span className="location-text">Sofitel Casablanca Tour Blanche</span>
          <br />
          <a
            href="https://www.google.com/maps/dir//Rue+Sidi+Belyout,+Casablanca+20000/@34.0021862,-6.7386955,15z/data=!4m8!4m7!1m0!1m5!1m1!1s0xda7d2831d49419d:0xa2519eade16227d4!2m2!1d-7.6141242!2d33.5978086?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            className="location-link"
            style={{ 
              textDecoration: "underline", 
              fontWeight: 500,
              display: "inline-flex",
              alignItems: "center",
              gap: 6
            }}
          >
            View on Google Maps
            <i className="fas fa-external-link-alt" style={{ fontSize: isMobile ? 10 : 12 }}></i>
          </a>
        </div>
      </div>
    </>
  );
}